import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IfFeatureDirective } from './directives/if-feature.directive';
import { UserPermissionsService } from './services/user-permissions.service';
import { IfFeatureAsyncDirective } from './directives/if-feature-async.directive';
import { IfNotFeatureDirective } from './directives/if-not-feature.directive';
import { IfNotFeatureAsyncDirective } from './directives/if-not-feature-async.directive';
import { FeatureGuard } from './guards/feature.guard';
import * as i0 from "@angular/core";
export class PermissionsModule {
    static { this.ɵfac = function PermissionsModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PermissionsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PermissionsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [UserPermissionsService, FeatureGuard], imports: [CommonModule] }); }
}
//# sourceMappingURL=permissions.module.js.map